import { Pipe, PipeTransform } from '@angular/core';
import type { Notification } from '@models/community/notification.model';
import {
  CommunityEventNotificationChrome,
  resolveCommunityEventNotificationChrome,
} from '@notifications/functions/community-event-notification.functions';

@Pipe({
  name: 'communityEventNotificationChrome',
  standalone: true,
  pure: true,
})
export class CommunityEventNotificationChromePipe implements PipeTransform {
  transform(item: Notification): CommunityEventNotificationChrome {
    return resolveCommunityEventNotificationChrome(item);
  }
}
